export default __webpack_public_path__ + "static/media/2.a922a4a5.png";